
const defaultConfig = {
	"THEME": "madamesum",
	"THEMES": ["madamesum", "madamesumuk"],
	"LOGIN_COOKIE": "utoken",
	"ACCUMULATOR": true,
	"ACCUMULATOR_COOKIE": "madamesumaccumulator",
	"FEATURE_ADDITIONALPRODUCTS": true,
	"FEATURE_CHILDPRODUCTS": true,
	"FEATURE_LIMITEDSTOCK": true,
	"FEATURE_RESERVETABLE": false,
	"FEATURE_ORDERBOX_LOGIN": false,
	"FEATURE_ORDERBOX_DELIVERY": true,
	"FEATURE_ORDERBOX_TAKEAWAY": true,
	"FEATURE_REFERRAL": true,
	"FEATURE_PLANZER_DELIVERY": true,
	"FEATURE_TIMESLOTS": true,
	"FEATURE_COUNTRY_REDIRECT": true,
	"FEATURE_ADDRESS_AUTOCOMPLETE": true,
	"BRAND": "madamesum",
	"LANGUAGE": "de",
	"LOCALE": "de_CH",
	"LOCAL_TIME": "",
	"LOCALE_DATE_FORMAT": "",
	"COUNTRY": "CH",
	"DEFAULT_CHANNEL": "planzer",
	"DEFAULT_ENTRYPOINT": "madamesum",
	"DEFAULT_TAXON_HIGHLIGHT_PRODUCTS": "all",
	"NOTIFY_MESSAGE": "",
	"NOTIFY_MESSAGE_TYPE": "",
	"DELIVERY_TIME": 15,
	"DELIVERY_TIMESLOT": 120,
	"TAKEAWAY_TIMESLOT": 15,
	"CONTAO_ENDPOINT": "",
	"SHOPMANAGER_ENDPOINT": "https://stage.shopmanager.madamesum.com/",
	"DATATRANS_SCRIPT": "https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js",
	"CART_COOKIE": "msbasket",
	"CHECKOUT_MERCHANT_ID": "1100004624",
	"SHOP_URL": "/de/shop",
	"HOME_URL": "/de/home",
	"CHECKOUT_URL": "/de/checkout",
	"CHECKOUT_SUCCESS_URL": "/de/checkout#success",
	"CHECKOUT_CANCEL_URL": "/de/checkout#cancel",
	"CHECKOUT_ERROR_URL": "/de/checkout#error",
	"CHECKOUT_COMPLETE_URL": "/de/checkout#complete",
	"LOGOUT_CONFIRM_URL": "/de/checkout#complete",
	"PASSWORD_RESET_URL": "",
	"REGISTER_CONFIRM_URL": "",
	"SHOPLIST_TAGS_SELECTOR": "#shoplist_tags",
	"ACCOUNT_QR_PREFIX": "ACC.",
	"COUNTRY_REDIRECT_COOKIE": "msredirect",
	"messages": [],

	// MOCK SECTION
	"MOCK": false,
	"MOCK_COOKIE": "madamesummock",
	"MOCK_PRODUCT_IMAGE": "",
	"MOCK_CHECKOUT_PREFILL": true,
	"MOCK_CART_HASALCOHOL": true,
	"MOCK_LOGIN": true,
	"MOCK_LOGIN_COOKIE": "madamesumlogin",
	"MOCK_ACCOUNT_HAS_ADDRESS": false,
	"MOCK_CARTOPEN_FAILONCE": false,
	"MOCK_SHOPLIST_LIMITSTOCK": false,
	"MOCK_CART_HASTIP": false,
	"MOCK_ORDERS_URL": "/files/mockdata/response/GET_orders.json",
	"MOCK_PRODUCTS_URL": "/files/mockdata/response/GET_products_by_slug.json",
	"MOCK_CART_CREATE_URL": "/files/mockdata/response/POST_carts.json",
	"MOCK_CART_GET_URL": "/files/mockdata/response/POST_carts_multiple-items.json",
	"MOCK_CATEGORIES_URL": "/files/mockdata/response/GET_taxons.json",
	"MOCK_CHECKOUT_URL": '/files/mockdata/response/GET_checkout.json',
	"MOCK_CHECKOUT_PAYMENT_URL": "/files/mockdata/response/GET_checkout_payment.json",
	"MOCK_CHECKOUT_SHIPPING_URL": "/files/mockdata/response/GET_checkout_shipping.json",
	"MOCK_ORDER_URL": "/files/mockdata/response/GET_order.json",
	"MOCK_ZIP_URL": "/files/mockdata/response/GET_zips.json",
	"MOCK_ACCOUNT_ME_URL": "/files/mockdata/response/GET_me.json",
	"MOCK_ACCOUNT_PRODUCTS_URL": "/files/mockdata/response/GET_products_by_slug.json",
	"MOCK_ACCOUNT_ADDRESSES_URL": "/files/mockdata/response/GET_address-book.json",
	"MOCK_LOCATIONRESERVATION_URL": "/files/mockdata/response/GET_reservation.json",
	"MOCK_CHANNELS_URL": "/files/mockdata/response/GET_channels.json",
	"MOCK_MIGRATE_BRANDS_URL": "/files/mockdata/response/POST_migrate-brands.json",

	// LANG STRINGS
	// "LANG_ORDER_BOX_TITLE": "Essen bestellen",

	// THEME VALUES
	"THEME_CURRENCY": "CHF",
	"THEME_CURRENCY_PREFIX": "CHF ",
	"THEME_COUNTRY": "CH",
	"THEME_COUNTRY_LIST": [
		'CH'
	],
	"THEME_ZIP_ATTRIBUTES": {
		minlength: 4,
		maxlength: 4,
		inputmode: 'numeric',
	},
	"THEME_ZIP_ALLOWED_CHARS": '0-9',
	"THEME_ZIP_REGEX": '^[0-9]{4}$',
	"THEME_RECAPTCHA_SITE_KEY": '',
	"THEME_REVERSE_STREET_NUMBER": false,
}

let themeConfig = {}
let overrideConfig = {}
let componentOptions = {}

function readFromCookie(config) {
	let cfg = {}
	cfg.MOCK = window.localStorage.getItem(config.MOCK_COOKIE) == "true"
	cfg.MOCK_CHECKOUT_PREFILL = window.localStorage.getItem(config.MOCK_COOKIE + "checkoutprefill") == "true"
	cfg.MOCK_ACCOUNT_HAS_ADDRESS = window.localStorage.getItem(config.MOCK_COOKIE + "accountaddress") == "true"
	cfg.MOCK_SHOPLIST_LIMITSTOCK = window.localStorage.getItem(config.MOCK_COOKIE + "limitstock") == "true"
	var accumulatorConfig = window.localStorage.getItem(config.ACCUMULATOR_COOKIE)
	cfg.MOCK_LOGIN = window.localStorage.getItem(config.MOCK_LOGIN_COOKIE) == "true"
	cfg.MOCK_CARTOPEN_FAILONCE = window.localStorage.getItem(config.MOCK_COOKIE + "cartopenfailonce") == "true"
	if(typeof accumulatorConfig === 'string'){
		cfg.ACCUMULATOR = window.localStorage.getItem(config.ACCUMULATOR_COOKIE) == "true"
	}
	return cfg
}
export function readFromComponentOptions(opts) {
	for (var i in opts) {
		if (defaultConfig.hasOwnProperty(i)) {
			componentOptions[i] = opts[i]
		}
	}
	updateConfig()
}
export function readFromHtmlJson() {
	let cfg = {}
	const el = document.querySelector("#baseconfig")
	if (el && el.getAttribute("type") == "application/json") {
		let data = JSON.parse(el.innerHTML.replace(/^\s+/, ""))
		Object.assign(cfg, data)
	}
	return cfg
}

export function setConfigValue(key, value) {
	overrideConfig[key] = value
	updateConfig()
}
export function setThemeConfig(config) {
	themeConfig = config
	updateConfig()
}

export function updateConfig() {
	let config = cfg || defaultConfig
	Object.assign(config, overrideConfig)
	Object.assign(config, themeConfig)
	Object.assign(config, readFromHtmlJson(config))
	Object.assign(config, readFromCookie(config))
	//Object.assign(config, readFromUrl(config))
	//Object.assign(config, readFromDev(config))
	//Object.assign(config, readFromHtml(config))
	//Object.assign(config, readFromRemote(config))
	//Object.assign(config, readFromUrl(config))
	Object.assign(config, overrideConfig)
	return config
}


var cfg = updateConfig()

//DEBUG: expose config
window.madamesum_config = cfg
export const config = cfg

export const vueConfig = {
	registerGlobalsComponentMap: {}
}
//export default config
